/* eslint-disable @typescript-eslint/no-unused-vars */
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function SocialSourceCard() {
  const [timeRange, setTimeRange] = useState("This Month");

  const totalBuyers = 70;
  const percentage = 70;

  const createGradient = (ctx: CanvasRenderingContext2D) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, 200);
    gradient.addColorStop(0, "hsl(151 65% 45%)");
    gradient.addColorStop(1, "hsl(151 65% 60%)");
    return gradient;
  };

  const data = {
    datasets: [
      {
        data: [percentage, 100 - percentage],
        backgroundColor: (context: any) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return "#1f2937";
          }
          if (context.dataIndex === 0) {
            return createGradient(ctx);
          }
          return "#1f2937";
        },
        borderWidth: 0,
        cutout: "80%",
      },
    ],
  };

  const options = {
    cutout: "80%",
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false },
    },
  };

  return (
    <div className="bg-background border border-surface-2 text-white rounded-xl p-4 w-[300px] flex flex-col items-center gap-12">
      {/* Header */}
      <div className="w-full flex items-start justify-between mb-4">
        <div>
          <p className="text-sm text-primary dark:text-primary">
            Social Source
          </p>
          <p className="text-xs text-primary dark:text-primary">
            Total Traffic In This Week
          </p>
        </div>
        <div className="flex items-center gap-1 text-sm bg-background border border-surface-2 text-primary px-2 py-1 rounded">
          {timeRange}
          <ChevronDown size={14} />
        </div>
      </div>

      {/* Chart */}
      <div className="relative w-[160px] h-[160px]">
        <Doughnut data={data} options={options} />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <p className="text-sm text-primary dark:text-primary">Total Buyer</p>
          <p className="text-2xl font-bold text-primary dark:text-primary">
            {totalBuyers}
          </p>
        </div>
      </div>

      {/* Buyer Info */}
      <div className="mt-6 w-full flex flex-col gap-3">
        <div className="flex items-center gap-2 text-sm">
          <span className="text-primary dark:text-primary flex items-center gap-1">
            <span role="img" aria-label="buyer">
              👤
            </span>
            Buyers :
          </span>
          <span className="text-indigo-400 font-medium">{totalBuyers}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <span className="text-primary dark:text-primary flex items-center gap-1">
            <span role="img" aria-label="growth">
              📈
            </span>
            Growth :
          </span>
          <span className="text-green-400 font-medium">+12.5%</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <span className="text-primary dark:text-primary flex items-center gap-1">
            <span role="img" aria-label="conversion">
              🔄
            </span>
            Conversion :
          </span>
          <span className="text-blue-400 font-medium">3.2%</span>
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-6 w-full flex justify-between border-t border-gray-700 pt-4">
        <button className="text-sm text-primary dark:text-primary hover:underline">
          See More Statistic
        </button>
        <button className="text-sm bg-gradientButton text-white px-4 py-1 rounded hover:bg-indigo-700">
          See Details
        </button>
      </div>
    </div>
  );
}
